import React from 'react';
import TopNavBar from '../NavBar/TopNavBar';
import LeftMenuBar from '../NavBar/LeftNavBar';
import Footer from '../Footer/Footer';
import './Layout.css';
import IState from '../../../core/models/IState';
import { connect } from 'react-redux';
import * as actions from '../../../core/actions/actions';

const Layout: React.FC<any> = (props) => {
    return (
        <div className="header-fixed sidebar-fixed sidebar-dark header-light" id="body">
            <div className="wrapper">
                <LeftMenuBar
                    changeLanguage={props.changeLanguage}
                    id={props.id}
                    userName={props.userName}
                    userId={props.userId}
                    userType={props.userType}
                />

                <div className="wrapper device-wrapper">
                    <TopNavBar />
                    <div className="content-wrapper">
                        <div className="container-fluid">
                            <div className="">
                                {props.children}
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


const mapStateToProps = (state: IState) => ({
    userName: state.auth.userName,
    id: state.auth.userId,
    userEmail: state.auth.userEmail,
    userId: state.auth.userId,
    userType: state.auth.userType
});


const mapDispatchToProps = (dispatch: any) => {
    return {
        changeLanguage: (lang: string) => dispatch(actions.changeLanguage(lang)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Layout);
